import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from '@/auth/main/route-guard/AuthGuard';
import AuthRoutes from '@/auth/main/routes/AuthRoutes';
import MainRoutes from '@/common/main/routes/MainRoutes';
import SomethingWentWrong from '@/common/presentation/components/SomethingWentWrong/SomethingWentWrong';
import ErrorBoundary from '@/common/presentation/components/ErrorBoundary/ErrorBoundary';
import { createBrowserRouter } from 'react-router-dom';
import CrmAccessGuard from '@/crm/main/CrmAccessGuard';

const CrmRoutes = lazy(() => import('@/crm/main/CrmRoutes'));

const CrmTopLevelRoute = {
  path: '/crm/*',
  errorElement: <SomethingWentWrong />,
  element: (
    <ErrorBoundary fallback={<Navigate to="/" replace />}>
      <AuthGuard>
        <CrmAccessGuard>
          <Suspense fallback={null}>
            <CrmRoutes />
          </Suspense>
        </CrmAccessGuard>
      </AuthGuard>
    </ErrorBoundary>
  )
};

const router = createBrowserRouter([AuthRoutes, MainRoutes, CrmTopLevelRoute], {
  basename: import.meta.env.VITE_APP_BASE_NAME || '/'
});

export default router;
